import { SvgIcon } from '@mui/material';
import { Icons } from './Icons';

type IconMap = {
    [key in string]: typeof SvgIcon;
};

export const TYPE_TO_ICON: IconMap = {
    Animal: Icons.Animal,
    Cast: Icons.Cast,
    'Creative Work': Icons.CreativeWork,
    Crew: Icons.Crew,
    Default: Icons.BuildCircleOutlined,
    'Digital Assets': Icons.DigitalAssets,
    Equipment: Icons.Equipement,
    Facility: Icons.Facility,
    Supplier: Icons.Organization,
    Place: Icons.OutlinedPlaceIcon,
    Product: Icons.Product,
    Prop: Icons.Prop,
    Service: Icons.Services,
    Vehicle: Icons.Vehicle,
    Wardrobe: Icons.WardrobeIcon,
    Report: Icons.Report,
    Create: Icons.AddOutlined,
    Corporate: Icons.Corporate
};
